import { ItemListOptionMetadata } from '@/contexts/item-context-types';
import { useCallback } from 'react';
import { useOrderGuideItemsContext } from '@/contexts/order-guide-items-context';

export const useGetOrderGuideItem = () => {
  const { variantPackPartitionMap } = useOrderGuideItemsContext();

  return useCallback(
    (optionMetadata: ItemListOptionMetadata) => {
      const { orderGuidePartitionUUID, variantPackUUID } = optionMetadata;
      if (!orderGuidePartitionUUID) {
        return null;
      }
      const partitionsForVP = variantPackPartitionMap[variantPackUUID];
      if (!partitionsForVP) {
        return null;
      }

      return partitionsForVP[orderGuidePartitionUUID] || null;
    },
    [variantPackPartitionMap],
  );
};
